import axios from "axios";

const IwoStatusService = {
  async getIwoStatus(serviceNo) {
    try {
      const response = await axios.get(
        `IwoStatus/GetIwoStatus?serviceNo=${serviceNo}`
      );

      console.log("IwoStatus API response:", response.data);

      return Array.isArray(response.data?.Data) ? response.data.Data : [];
    } catch (error) {
      console.error("Error fetching IWO status:", error);
      throw error;
    }
  },


  async updateIwoStatus(iwoNo, status, completedDate, completedBy) {
    try {
      const body = new URLSearchParams();
      body.append("iwoNo", iwoNo);
      body.append("status", status);
      body.append("completedDate", completedDate || "");
      body.append("completedBy", completedBy || "");

      const response = await axios.post("IwoStatus/UpdateIwoStatus", body, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      console.log("UpdateIwoStatus API response:", response.data);

      return response.data;
    } catch (error) {
      console.error("Error updating IWO status:", error);
      throw error;
    }
  },
};

export default IwoStatusService;